import { UserOrderRoutes } from 'src/app/core/enums/routes.enum';
import { ORDER_STATUS_LABELS } from '../enums/order-status.enum';

export function getLinkToOrderStage(stage: number): string {
  const route = `${UserOrderRoutes.Main}${ORDER_STATUS_LABELS[stage]}`;
  return (
    Object.values(UserOrderRoutes).find((orderRoute) => orderRoute === route) ??
    UserOrderRoutes.Draft
  );
}
